import { useEffect, useMemo } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { FragmentRemoteComponent } from '@constructor/federation/react'
// @ts-expect-error
import knowledgeCenterRemote from 'virtual:federation/remotes/knowledge-center'
import { useKnowledgeModelSettings } from '@/features/km/useKnowledgeModelSettings'
import { useGetObjectiveAccessByIdQuery } from '@/store/api/aggregatesApi'
import { useAppSelector } from '@/store/hooks'
import { useIsObjectiveNotAvailable } from './useIsObjectiveNotAvailable'
import { useKnowledgeModelChat } from './useKnowledgeModelChat'
import { useKnowledgeModelId } from './useKnowledgeModelId'

export const KnowledgeModelWidget = () => {
  const location = useLocation()
  const params = useParams()
  const objectiveId = params?.objectiveId as string
  const settings = useKnowledgeModelSettings(objectiveId)

  const { data: aggregate } = useGetObjectiveAccessByIdQuery(objectiveId, {
    skip: !objectiveId,
  })

  const aggregateCurrent = useAppSelector((store) => store.aggregate.current)

  const aggregateId = aggregateCurrent?.id || params?.aggregateIdParam
  const isCourseDetail = Boolean(location.pathname.includes('/courses') && aggregateId)

  const { isObjectiveNotAvailable } = useIsObjectiveNotAvailable(aggregate)

  const skipFetchObjectiveKnowledgeModelQuery = useMemo(() => {
    return !isCourseDetail || !settings?.enabled || isObjectiveNotAvailable
  }, [isCourseDetail, isObjectiveNotAvailable, settings?.enabled])

  const { knowledgeModelId } = useKnowledgeModelId({
    aggregateId,
    skip: skipFetchObjectiveKnowledgeModelQuery,
    isCourseDetail,
  })

  const { initChat } = useKnowledgeModelChat({ knowledgeModelId, initialExpanded: settings.initialExpanded })

  useEffect(() => {
    const isProctoringWrapped = window.location.href.includes('inProctoringIframe')

    if (isProctoringWrapped) {
      return
    }

    if (!knowledgeModelId || isObjectiveNotAvailable) {
      return
    }

    initChat()
  }, [initChat, isObjectiveNotAvailable, knowledgeModelId])

  if (!knowledgeModelId || isObjectiveNotAvailable) {
    return null
  }

  return <FragmentRemoteComponent remote={knowledgeCenterRemote} entryName="chatWidgetInternal" />
}
